import useResize from '@/hooks/useResize';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAppSelector } from '@/redux/store.hook';
import { getAuthSelector } from '@/redux/auth/auth.slice';
import PATH from '@/router/path';
import { Text } from '@/components/UI/Typography/Text';
import { Button } from '@mui/material';
import { Box, Flex } from '@/layout';
import {
    ContentTitle,
    ContentSection,
    SectionContent,
    GradientCardGrid,
    GradientCard,
    GradientCardTitle,
    GradientCardDescription,
    FeatureCardItems,
    Hr,
} from '../style';


const DealMakingPortal = () => {
    //   @ts-ignore
    const { t } = useTranslation();
    const { isTablet, isMobile } = useResize();
    const auth = useAppSelector(getAuthSelector);
    const { isLogin } = auth;

    const featureItems = t('pages.index.GoGlobal.dealMaking.features.items', { returnObjects: true }) as Array<{ title: string, description: string, descriptionArray: { title: string, description: string }[] }>;
    const serviceItems = t('pages.index.GoGlobal.dealMaking.services.items', { returnObjects: true }) as Array<{ icon: string, title: string, description: string, descriptionArray: { title: string, description: string }[] }>;

    return (
        <>
            <Flex flexDirection={'column'} gridGap={'20px'} marginBottom={'80px'}>
                <ContentTitle textAlign={'center'} isMobile={isMobile}>{t('pages.index.GoGlobal.dealMaking.title')}</ContentTitle>
                <Text textAlign={'center'} fontWeight={'bold'} fontSize={'24px'}>
                    {t('pages.index.GoGlobal.dealMaking.subtitle')}
                </Text>
                <SectionContent isMobile={isMobile}>
                    {
                        t('pages.index.GoGlobal.dealMaking.intro').split('\n').map((line, i) => (
                            <span key={i}>{line}<br /></span>
                        ))
                    }
                </SectionContent>
                <GradientCardGrid isMobile={isMobile} isTablet={isTablet} gridRepeat='repeat(1, 1fr)' gridGap='20px'>
                    {featureItems.map((item, index) => (
                        <GradientCard key={index} isMobile={isMobile}>
                            <GradientCardTitle textAlign={'center'} isMobile={isMobile}>{item.title}</GradientCardTitle>
                            <Hr />
                            <Box padding={isMobile ? '0' : '0 10px'}>
                                <FeatureCardItems isMobile={isMobile}>
                                    {item.descriptionArray.map((line, i) => (
                                        <GradientCardDescription as="div" lineHeight={'30px'} isMobile={isMobile} key={i}>
                                            <Text fontWeight={'bold'}>{line.title}</Text>
                                            <Box fontSize={'16px'} marginBottom={'10px'}>{line.description}</Box>
                                        </GradientCardDescription>
                                    ))}
                                </FeatureCardItems>
                            </Box>
                        </GradientCard>
                    ))}
                </GradientCardGrid>
            </Flex>


            <Flex flexDirection={'column'} gridGap={'20px'} marginBottom={'80px'}>
                <ContentTitle textAlign={'center'} isMobile={isMobile}>{t('pages.index.GoGlobal.dealMaking.services.title')}</ContentTitle>
                <SectionContent isMobile={isMobile} textAlign='center'>
                    {t('pages.index.GoGlobal.dealMaking.services.intro')}
                </SectionContent>
                <GradientCardGrid isMobile={isMobile} isTablet={isTablet} gridRepeat={'repeat(2, 1fr)'} gridGap='20px'>
                    {serviceItems.map((item, index) => (
                        <GradientCard padding={'30px 50px'} key={index} isMobile={isMobile}>
                            <Flex gridGap={'20px'} height={'100%'}>
                                <Flex justifyContent={'center'} alignItems={'center'}>
                                    <img src={item.icon} alt={item.title} />
                                </Flex>
                                <Flex flexDirection={'column'} gridGap={'8px'} justifyContent={'center'}>

                                    <GradientCardTitle fontSize={'24px'} isMobile={isMobile}>{item.title}</GradientCardTitle>
                                    <GradientCardDescription isMobile={isMobile}>
                                        {item.description.split('\n').map((line, i) => (
                                            <span key={i}>{line}<br /></span>
                                        ))}
                                    </GradientCardDescription>
                                </Flex>
                            </Flex>
                        </GradientCard>
                    ))}
                </GradientCardGrid>
            </Flex>
            {
                !isLogin && (
                    <ContentSection isMobile={isMobile}>
                        <ContentTitle textAlign={'center'} isMobile={isMobile}>{t('pages.index.GoGlobal.dealMaking.cta.title')}</ContentTitle>
                        <div style={{ textAlign: 'center', marginTop: '30px' }}>
                            <Link to={PATH.auth.signUp}>
                                <Button variant="contained" color="primary">
                                    {t('pages.index.GoGlobal.dealMaking.cta.button')}
                                </Button>
                            </Link>
                        </div>
                    </ContentSection>
                )
            }
        </>
    );
};

export default DealMakingPortal;
